import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaList } from "react-icons/fa";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { IoIosHome } from "react-icons/io";
import { FaBorderAll } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import { IoMdLogOut } from "react-icons/io";
import { RiLockPasswordLine } from "react-icons/ri";
import api from "../api/api";
import { useDispatch } from "react-redux";
import { user_reset } from "../store/reducers/authReducer";
import { reset_count } from "../store/reducers/cardReducer";

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location, isMobile]);

  const logout = async () => {
    try {
      await api.get("/customer/logout");
      localStorage.removeItem("customerToken");
      dispatch(user_reset());
      dispatch(reset_count());
      navigate("/login");
    } catch (error) {}
  };

  const menuItems = [
    { icon: <IoIosHome />, text: "Panel de Usuario", path: "/dashboard" },
    {
      icon: <FaBorderAll />,
      text: "Mis Pedidos",
      path: "/dashboard/my-orders",
    },
    {
      icon: <FaHeart />,
      text: "Lista de Deseo",
      path: "/dashboard/my-wishlist",
    },
    {
      icon: <IoChatbubbleEllipsesSharp />,
      text: "Chat de Soporte",
      path: "/dashboard/chat",
    },
    {
      icon: <RiLockPasswordLine />,
      text: "Cambiar Contraseña",
      path: "/dashboard/change-password",
    },
  ];

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#eeeeee]">
      <Header />

      <div className="flex-grow container mx-auto px-4 py-6">
        {/* Toggle Button - Solo visible en móvil */}
        <div className="md:hidden mb-4">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="flex items-center gap-2 p-3 bg-[#048265] text-white rounded-lg transition-all shadow-md"
            aria-label="Toggle Menu"
          >
            <FaList />
            <span>Menú</span>
          </button>
        </div>

        <div className="flex flex-col md:flex-row gap-6">
          {/* Sidebar */}
          <aside
            className={`
              fixed md:relative
              w-72 md:w-64 lg:w-72
              h-full
              top-0 left-0
              bg-white rounded-r-2xl md:rounded-lg
              shadow-lg
              overflow-y-auto
              transition-all duration-300 ease-in-out
              z-50
              ${
                sidebarOpen
                  ? "translate-x-0"
                  : "-translate-x-full md:translate-x-0"
              }
            `}
          >
            <nav className="p-4">
              <ul className="space-y-2">
                {menuItems.map((item, index) => (
                  <li key={index}>
                    <Link
                      to={item.path}
                      className={`
                        flex items-center gap-3 p-4
                        rounded-lg transition-all
                        hover:bg-green-50 hover:text-green-600
                        ${
                          isActivePath(item.path)
                            ? "bg-green-100 text-green-600 font-medium"
                            : "text-slate-600"
                        }
                      `}
                      onClick={() => isMobile && setSidebarOpen(false)}
                    >
                      <span className="text-xl">{item.icon}</span>
                      <span className="text-sm">{item.text}</span>
                    </Link>
                  </li>
                ))}
                <li>
                  <button
                    onClick={logout}
                    className="w-full flex items-center gap-3 p-4 text-slate-600 
                             hover:bg-red-50 hover:text-red-600
                             rounded-lg transition-all"
                  >
                    <span className="text-xl">
                      <IoMdLogOut />
                    </span>
                    <span className="text-sm">Cerrar Sesión</span>
                  </button>
                </li>
              </ul>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="w-full md:w-8/12">
            <div className="bg-white rounded-lg shadow-md">
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      <Footer />

      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Dashboard;
